import React, { useEffect, useState } from "react";

export default function Step5Success({
  onDashboardClick = () => {},
  onContactClick = () => {},
}) {
  const [countdown, setCountdown] = useState(5);

  // Countdown timer
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  return (
    <div
      className="success-page"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: "20px",
        backgroundColor: "#f4f4f4",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          padding: "40px",
          maxWidth: "500px",
          width: "100%",
          textAlign: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#e6f3ff",
            borderRadius: "50%",
            width: "100px",
            height: "100px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#09aff4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
        </div>

        <h2 style={{ color: "#09aff4", marginBottom: "15px" }}>
          Registration Complete
        </h2>

        <p style={{ color: "#333", marginBottom: "20px" }}>
          Your payment has been processed successfully. You'll be redirected to
          the dashboard in{" "}
          <span style={{ fontWeight: "bold", color: "#09aff4" }}>
            {countdown}
          </span>{" "}
          seconds.
        </p>

        <div
          style={{
            backgroundColor: "#f0f0f0",
            borderRadius: "8px",
            padding: "20px",
            marginBottom: "20px",
          }}
        >
          <p style={{ fontWeight: "600", marginBottom: "15px" }}>
            Confirmation Email Sent
          </p>
          <ul
            style={{
              listStyleType: "none",
              padding: 0,
              textAlign: "left",
            }}
          >
            {[
              "Account details",
              "Payment receipt",
              "Getting started guide",
            ].map((item, index) => (
              <li
                key={index}
                style={{
                  marginBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#09aff4"
                  strokeWidth="2"
                  style={{ marginRight: "10px" }}
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <button
            onClick={onDashboardClick}
            style={{
              backgroundColor: "#09aff4",
              color: "white",
              border: "none",
              padding: "12px 20px",
              borderRadius: "6px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#0788c9")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#09aff4")}
          >
            Go to Dashboard
          </button>
          <button
            onClick={onContactClick}
            style={{
              backgroundColor: "transparent",
              color: "#666",
              border: "none",
              padding: "10px",
              fontSize: "0.9rem",
              cursor: "pointer",
            }}
          >
            Need help? Contact Support
          </button>
        </div>
      </div>
    </div>
  );
}
